"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GenesysSupportCenterSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const GenesysSupportCenterSkeleton = ()=>{
    // Landing page is rendered when there is no or empty or "/" hash in the URL
    const isLandingPage = (0, _presentationUtils.isSSR)() ? true : window.location.hash.replace('#/', '') === '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.HeaderSkeleton, {
                className: _constants.GENESYS_SUPPORT_CENTER_SKELETON,
                variant: "rectangular",
                width: "100%"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
                children: isLandingPage ? Array.from({
                    length: 8
                }).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CategorySkeleton, {
                        className: _constants.GENESYS_SUPPORT_CENTER_SKELETON,
                        variant: "rectangular"
                    }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                    className: _constants.GENESYS_SUPPORT_CENTER_SKELETON,
                    variant: "rectangular",
                    width: "984px",
                    height: 380
                })
            })
        ]
    });
};
exports.GenesysSupportCenterSkeleton = GenesysSupportCenterSkeleton;
